import React from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'accent';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
}

const variantClasses: Record<Variant, string> = {
  primary:
    'bg-brand-500 text-white hover:bg-brand-600 focus-visible:ring-brand-300 disabled:bg-brand-300',
  secondary:
    'bg-white text-ink border border-surface-subtle hover:bg-surface-muted focus-visible:ring-brand-200 disabled:text-ink-faint',
  danger:
    'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-300 disabled:bg-red-300',
  accent:
    'bg-accent-500 text-white hover:bg-accent-600 focus-visible:ring-accent-300 disabled:bg-accent-300',
};

// Also used to style links (e.g. react-router <Link>) as buttons.
export const buttonClasses = (variant: Variant = 'primary', fullWidth = false, className = '') =>
  [
    'inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold shadow-sm transition-colors duration-150',
    'focus-visible:outline-none focus-visible:ring-4',
    'disabled:cursor-not-allowed',
    variantClasses[variant],
    fullWidth ? 'w-full' : '',
    className,
  ].join(' ');

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) => {
  return (
    <button className={buttonClasses(variant, fullWidth, className)} {...rest}>
      {children}
    </button>
  );
};

export default Button;
